var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 2.91L2.91 0l14.946 14.946-2.91 2.91z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.946.183l2.912 2.912L2.912 18.04 0 15.129z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMi45MTAxNiIgd2lkdGg9IjQuMTE1NDUiIGhlaWdodD0iMjEuMTM3IiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgMCAyLjkxMDE2KSIgZmlsbD0id2hpdGUiLz4KPHJlY3QgeD0iMTQuOTQ2MyIgeT0iMC4xODI2MTciIHdpZHRoPSI0LjExODMxIiBoZWlnaHQ9IjIxLjEzNyIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTQuOTQ2MyAwLjE4MjYxNykiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgClose as ReactComponent };